
import { Activity } from '@cms-max/medicare-api-sdk'
import { Tooltip } from '@cmsgov/ds-medicare-gov'
import classNames from 'classnames'
import { SiteActivityComponent } from 'models/activity'
import { CoreEvent, EventGeneric, TealiumEvent } from 'models/activity/v2'
import { FC } from 'react'
import { createEventWithDefaults } from 'utils/activity'

interface MyTooltipSiteActivityProps {
  component: SiteActivityComponent
  linkText: string
}

export type MyTooltipSiteActivityPropsV2 = EventGeneric<
  Omit<CoreEvent, 'activity' | 'property'>,
  TealiumEvent
>

type MyTooltipProps = {
  siteActivityProps?: MyTooltipSiteActivityProps | MyTooltipSiteActivityPropsV2
} & Omit<Parameters<typeof Tooltip>[0], 'ref'>

/**
 * Wraps the design system tooltip component so that we can use site activity tracking
 * @param
 * @returns
 */
export const MyTooltip: FC<MyTooltipProps> = ({ siteActivityProps, onOpen, className, ...props }) => {
  const handleOnOpen = () => {
    if (siteActivityProps) {
      const activityPropsv1 = siteActivityProps as MyTooltipSiteActivityProps
      if (activityPropsv1.component) {
        window.globalHeaderEvents?.sendSiteActivityMetrics(
          // TODO: Update to tooltip view event or something?
          'Link Click',
          'MAX',
          activityPropsv1.component,
          {
            linkText: activityPropsv1.linkText
          }
        )
      }
      const activityPropsv2 = siteActivityProps as MyTooltipSiteActivityPropsV2
      if (activityPropsv2.core || activityPropsv2.tealium) {
        const defaults = {
          core: {
            property: 'MAX',
            // TODO: Update to tooltip view event or something?
            activity: Activity.LinkClick
          }
        }
        const event = createEventWithDefaults(defaults, activityPropsv2)
        window.globalHeaderEvents?.handleEvent(event)
      }
    }

    if (onOpen) {
      onOpen()
    }
  }
  const classes = classNames('my-c-tooltip', className)
  return (
    <Tooltip
      {...props}
      className={classes}
      onOpen={handleOnOpen}
    />
  )
}
